import React from 'react'
import { Icon } from '@chakra-ui/react'

export function IconKeywordFinder(rest) {
  return (
    <Icon viewBox="0 0 32 32" {...rest}>
      <g fillRule="evenodd" fill="currentColor" clipRule="evenodd">
        <path d="m12.1555415 16.0141038c-.1737581.4226877-.7767355.4099644-.9325087-.0196768l-1.69309091-4.6697468c-.09412425-.2596059.04002515-.5463608.29963107-.6404851.25960594-.0941243.54636094.0400251.64048514.2996311l1.2522834 3.4539469 1.2013897-2.9225272c.169242-.4117018.7516253-.4136505.9236187-.0030905l1.1944903 2.85133 1.2595827-3.5314582c.0927688-.2600933.3788201-.3957367.6389135-.3029679s.3957367.3788201.3029679.6389135l-1.6930909 4.7468734c-.1534085.4301073-.7556655.4464035-.9321087.0252215l-1.227558-2.9302648z" />
      </g>
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1}
      >
        <path d="m27.0421818 24.7512727-2.2545454 2.2538182-5.7876364-5.7876364 2.2909091-2.2174545z" />
        <path d="m12.9996208 3.5c-5.2464388 0-9.4996208 4.25346634-9.4996208 9.5 0 5.2470242 4.25291422 9.5 9.4996208 9.5 5.2473536 0 9.5003792-4.2528644 9.5003792-9.5 0-5.24664506-4.2532934-9.5-9.5003792-9.5z" />
      </g>
    </Icon>
  )
}
